import { useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Formats from "@/components/Formats";
import Levels from "@/components/Levels";
import Styles from "@/components/Styles";
import About from "@/components/About";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import WhatsAppButton from "@/components/WhatsAppButton";
import { scrollToId } from "@/lib/scroll";

export default function Landing() {
  const [authOpen, setAuthOpen] = useState(false);
  const [presetFormat, setPresetFormat] = useState(null);

  const handleSelectFormat = (formatId) => {
    setPresetFormat(formatId);
    scrollToId("#agendar");
  };

  return (
    <div className="min-h-screen bg-[#05070D] text-slate-100">
      <Navbar onOpenAuth={() => setAuthOpen(true)} />
      <main>
        <Hero />
        <Marquee />
        <Formats onSelect={handleSelectFormat} />
        <Levels />
        <Styles />
        <About />
        <Booking presetFormat={presetFormat} onOpenAuth={() => setAuthOpen(true)} />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
}
